<template>
    <div>
      <b-row class="mt-3">
        <b-col cols="5">
          <b-form-group label="Report Type: "  :label-cols="3" >
            <b-form-select class="form-control input" v-model="reportType" @change="handleReportChange">
              <option :value="null"  >--Please Select Type--</option>
                <option value="daywise">Day Wise</option>
                <option value="monthwise">Month Wise</option>
              </b-form-select>          
          </b-form-group> 
        </b-col>
        <b-col cols="5">
          <b-form-group label="Hub : "  :label-cols="3" v-show="reportType=='daywise' || reportType=='monthwise' && this.isSuperAdmin != 1">
            <b-form-select class="form-control input" v-model="destinationhubid" :disabled="isSuperAdmin!=1" key="hub_select">
              <option :value="null"  >--Please Select Hub--</option>
                <option v-for="hub in hublist" :key="hub.pickuplocationmasterid" v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
              </b-form-select>          
          </b-form-group> 
          <span v-show="reportType=='monthwise' && this.isSuperAdmin == 1">
            <ejs-multiselect id='multiselect' key="hub_multiselect" placeholder="Select Hub" v-model="destinationhubidMultiple" :dataSource='destinationOptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
            ></ejs-multiselect> 
          </span>
        </b-col>
        <b-col cols="4">
          <b-form-group label="From Date : "  :label-cols="3" v-if="reportType=='daywise'">
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="fromDate"
            >
            </v-date-picker>
          </b-form-group>
          <b-form-group label="Select Month: "  :label-cols="4" v-if="reportType=='monthwise'">
            <date-picker 
              v-model="selectedMonth" 
              format="MM-YYYY" 
              type="month" 
              placeholder="Please Select Month"
              @input="setStartEndForMonth()"
            ></date-picker>
          </b-form-group> 
        </b-col>
        <b-col cols="4">
          <b-form-group label="To Date : "  :label-cols="3" v-if="reportType=='daywise'">
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: null, end: new Date() }"
              v-model="toDate"
            >
            </v-date-picker>
          </b-form-group>

          <b-form-group label="From Date: "  :label-cols="3" v-if="reportType=='monthwise'">
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: firstDayOfSelectedMonth, end: lastDayOfSelectedMonth }"
              v-model="from_month_date"
              @input="resetToMonthDate()"
            >
            </v-date-picker>
          </b-form-group>
          
          <b-form-group label="To Date : "  :label-cols="3" v-if="reportType=='monthwise'">
            <v-date-picker
              mode="single"
              input-class="dateInput"
              :available-dates="{ start: from_month_date, end: lastDayOfSelectedMonth }"
              v-model="to_month_date"
              @input="checkIfGreaterThanFromMonthDate()"
            >
            </v-date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getHubOFDListing(1)" v-if="reportType!=null"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()" v-if="reportType!=null"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        <b-col cols="2" style="text-align:right;">
            <b-form-group>
              <button class="btn btn-primary" @click="getReport" :disabled="totalRows==0" v-if="reportType!=null">Download </button>                       
            </b-form-group>
        </b-col>
      </b-row>
      <b-row class="my-2"> 
        <b-col sm="12" class="text-right">
            <b-col sm="12">  
            <p v-if="reportType!=null"> <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
            </b-col>
        </b-col> 

        <b-col sm="12" v-if="reportType=='daywise'">
          <b-table 
            show-empty 
            responsive
            :items="items" 
            :busy="isBusy" 
            :current-page="currentPage"
            :fields="dayFields" 
            :per-page="perPage" 
            :bordered="bordered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="inscan_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'inscan_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.inscan_count }}</span>
              </button>
            </template>

            <template slot="total_shipment_in_hub" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'total_shipment_in_hub')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.total_shipment_in_hub }}</span>
              </button>
            </template>

            <template slot="ofd_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'ofd_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.ofd_count }}</span>
              </button>
            </template>

            <template slot="ofd_pending_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'ofd_pending_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.ofd_pending_count }}</span>
              </button>
            </template>

            <template slot="dlv_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'dlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.dlv_count }}</span>
              </button>
            </template>

            <template slot="undlv_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'undlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.undlv_count }}</span>
              </button>
            </template>

            <template slot="rto_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'rto_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.rto_count }}</span>
              </button>
            </template>

            <template slot="firstattempt_dlv_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'firstattempt_dlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.firstattempt_dlv_count }}</span>
              </button>
            </template>

            <template slot="diffday_ofd_count" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'diffday_ofd_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.diffday_ofd_count }}</span>
              </button>
            </template>
          </b-table>
        </b-col>

        <b-col sm="12" v-if="reportType=='monthwise'">
          <b-table 
            show-empty 
            responsive
            :items="items" 
            :busy="isBusy" 
            :current-page="currentPage"
            :fields="monthFields" 
            :per-page="perPage" 
            :bordered="bordered"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <template slot="hub_name" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.hub_name }}</span>
              <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.hub_name }}</b></span>
            </template>
            <template slot="inscan_month" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.inscan_month }}</span>
              <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.inscan_month }}</b></span>
            </template>
            <template slot="inscan_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'inscan_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.inscan_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.inscan_count }}</b></span>
              </button>
            </template>

            <template slot="ofd_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'ofd_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.ofd_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.ofd_count }}</b></span>
              </button>
            </template>

            <template slot="ofd_pending_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'ofd_pending_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.ofd_pending_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.ofd_pending_count }}</b></span>
              </button>
            </template>

            <template slot="delivery_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.delivery_percent }}</span>
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.delivery_percent }}</b>
                </button>
              </span>
            </template>

            <template slot="dlv_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'dlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.dlv_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.dlv_count }}</b></span>
              </button>
            </template>

            <template slot="undelivery_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.undelivery_percent }}</span>
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.undelivery_percent }}</b>
                </button>
              </span>
            </template>

            <template slot="undlv_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'undlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.undlv_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.undlv_count }}</b></span>
              </button>
            </template>

            <template slot="rto_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.rto_percent }}</span>
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.rto_percent }}</b>
                </button>
              </span>
            </template>

            <template slot="rto_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'rto_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.rto_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.rto_count }}</b></span>
              </button>
            </template>

            <template slot="pending_rtd_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'pending_rtd_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.pending_rtd_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.pending_rtd_count }}</b></span>
              </button>
            </template>

            <template slot="first_attempt_delivery_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.first_attempt_delivery_percent }}</span>
              <!-- <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.first_attempt_delivery_percent }}</b></span> -->
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.first_attempt_delivery_percent }}</b>
                </button>
              </span>
            </template>

            <template slot="firstattempt_dlv_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'firstattempt_dlv_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.firstattempt_dlv_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.firstattempt_dlv_count }}</b></span>
              </button>
            </template>

            <template slot="diffday_ofd_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'diffday_ofd_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.diffday_ofd_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.diffday_ofd_count }}</b></span>
              </button>
            </template>

            <template slot="diffday_ofd_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.diffday_ofd_percent }}</span>
              <!-- <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.diffday_ofd_percent }}</b></span> -->
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.diffday_ofd_percent }}</b>
                </button>
              </span>
            </template>

            <template slot="cpc_count" slot-scope="row">
              <button v-if="row.item.hub_name!='Total'" title="View Details" @click="viewDetails(row.item,'cpc_count')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.cpc_count }}</span>
              </button>
              <button v-if="row.item.hub_name=='Total'" style="background-color: white !important;" class="btn btn-link">
                <span style="color:black;"><b>{{ row.item.cpc_count }}</b></span>
              </button>
            </template>

            <template slot="not_delivered_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.not_delivered_percent }}</span>
              <!-- <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.diffday_ofd_percent }}</b></span> -->
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.not_delivered_percent }}</b>
                </button>
              </span>
            </template>
            
            <template slot="not_rto_percent" slot-scope="row">
              <span v-if="row.item.hub_name!='Total'">{{ row.item.not_rto_percent }}</span>
              <!-- <span v-if="row.item.hub_name=='Total'"><b>{{ row.item.diffday_ofd_percent }}</b></span> -->
              <span v-if="row.item.hub_name=='Total'">
                <button style="background-color: white !important;" class="btn btn-link">
                  <b>{{ row.item.not_rto_percent }}</b>
                </button>
              </span>
            </template>
          </b-table>

        </b-col>
        <b-col sm="12" class="my-1" v-if="this.totalRows>10">
          <paginate 
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="getHubOFDListing"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :current-page="currentPage"
          >
          </paginate>
        </b-col> 
        <b-modal size="xl" title="Details" v-model="detailsModal" hide-footer>
          <b-row>
            <b-col sm="12" class="text-right">
              <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
            </b-col>
            <b-col sm="8" class="my-1">
              <paginate 
                :page-count="noofpages1"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                v-model="currentPage1"
              >
              </paginate>
            </b-col> 
            <b-col sm="4" class="text-right">
              <b-form-group>
                <button class="btn btn-primary" @click="countDetailsReport" :disabled="totalRowsCount==0">Download </button>                       
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-table
                show-empty 
                responsive 
                :items="items1" 
                :busy="isBusy1" 
                :fields="fields1" 
                :per-page="perPage1" 
                :bordered="bordered"
              >

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              </b-table>
            </b-col>
            <b-col sm="12" class="my-1">
              <paginate 
                :page-count="noofpages1"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                v-model="currentPage1"
              >
              </paginate>
            </b-col> 
          </b-row>
        </b-modal>
      </b-row>
    </div>
</template> 

<script>
import CONSTANTS from '@/utils/constants'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
  export default {
    components: {
      DatePicker
    },
    data: function(){
      return{
        name: 'hubWiseOFDReport_KSA',
        isBusy: false,
        items: [],
        //fields:[],
        dayFields: [
          {key:'hub_name',label:'HUB Name'},
          {key:'inscan_date',label:'Date'},
          {key:'inscan_count',label:'Hub Inscanned (Fresh Shipment) Count'},
          {key:'total_shipment_in_hub',label:'Total Shipment in HUB'},
          {key:'ofd_count',label:'OFD (Out for Delivery) Count'},
          {key:'ofd_pending_count',label:'OFD Pending'},
          {key:'delivery_percent',label:'Delivery Percentage'},
          {key:'dlv_count',label:'Delivery Count'},
          {key:'undlv_count',label:'Undelivery Count'},
          {key:'undelivery_percent',label:'Undelivery Percentage'},
          {key:'rto_count',label:'RTO (Return to Origin) Count'},
          {key:'rto_percent',label:'RTO Percentage'},
          {key:'first_attempt_delivery_percent',label:'First Attempt Delivery Percentage'},
          {key:'firstattempt_dlv_count',label:'First Attempt Delivery Count'},
          {key:'diffday_ofd_count',label:'Different Day OFD Count'},
          {key:'diffday_ofd_percent',label:'Different Day OFD Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        noofpages: 0,
        destinationhubid:null,
        reportType:null,
        hublist:[],
        toDate:new Date(),
        fromDate:new Date(),
        downloadreport:'',
        isSuperAdmin:0,

        //monthwise report
        selectedMonth:new Date(),
        from_month_date: null,
        to_month_date: null,
        firstDayOfSelectedMonth : null, //new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1).toLocaleDateString(),
        lastDayOfSelectedMonth :  null, //new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0).toLocaleDateString(),
        monthFields:[
          {key:'hub_name',label:'HUB Name'},
          {key:'inscan_month',label:'Month'},
          {key:'inscan_count',label:'Hub Inscanned (Fresh Shipment) Count'},
          {key:'ofd_count',label:'OFD Count'},
          {key:'ofd_pending_count',label:'OFD Pending Count'},
          {key:'delivery_percent',label:'Delivery Percentage'},
          {key:'dlv_count',label:'Delivery Count'},
          {key:'undelivery_percent',label:'Pending Percentage'},
          {key:'undlv_count',label:'Pending Count'},
          {key:'rto_percent',label:'RTO Percentage'},
          {key:'rto_count',label:'RTO Count'},
          {key:'pending_rtd_count',label:'Pending RTD Count'},
          {key:'first_attempt_delivery_percent',label:'First Attempt Delivery Percentage'},
          {key:'firstattempt_dlv_count',label:'First Attempt Delivery Count'},
          {key:'diffday_ofd_count',label:'Different Day OFD Count'},
          {key:'diffday_ofd_percent',label:'Different Day OFD Percentage'},
          {key:'cpc_count',label:'CPC Count'},
          {key:'not_delivered_percent',label:'Not Delivered Percentage'},
          {key:'not_rto_percent',label:'Not RTO Percentage'},
        ],

        //modal fields
        detailsModal:false,
        isBusy1: false,
        items1:[],
        fields1:[
          {key:'shippingid',label:'Shipping Id [Order Id]'},
          {key:'pickuplocationname',label:'Pickup Location Name'},
          {key:'servicetype',label:'Service Type'},
          {key:'shipmentstatus',label:'Shipment Status'},
          {key:'deliverystatus',label:'Delivery Status'},
          {key:'agent_name',label:'Agent Name'},
          {key:'customer_name_no',label:'Customer Name & Mob No.'},
          {key:'vendor_name',label:'Vendor Name'},
          {key:'da_mo_no',label:'DA Mobile Number'},
          {key:'delivery_addr',label:'Delivery Address'},
          {key:'ordertype',label:'Order Type'},
          {key:'createddate',label:'Created Date'},
          {key:'lastmodifieddate',label:'Last Modified Date'}
        ],
        totalRowsCount:0,
        currentPage1: 1,
        noofpages1: 0,
        perPage1:0,
        countDetails: {},
        countName: '',

        // multiple hub selection values
        destinationhubidMultiple : [],
        agentmaster:[],
        agentfields: { text: 'name', value: 'id' },
        destinationOptions: [],
        showSelectAll : true,
        allowCustomValue : true,
      }
    },
    created: function(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isSuperAdmin = userInfo.is_superadmin
      var hubId = userInfo.pickuplocationmasterid;
      this.destinationhubid= this.isSuperAdmin != 1 ? hubId : null
      this.getHublist();
      //this.getHubwiseOFDListing(1)
      this.firstDayOfSelectedMonth = this.formatDate(new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1));
      this.lastDayOfSelectedMonth = this.formatDate(new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0));
    
      console.log('this.firstDayOfSelectedMonth',this.firstDayOfSelectedMonth)
      console.log('this.lastDayOfSelectedMonth',this.lastDayOfSelectedMonth)
    },

    mounted() {
    // Initialize the start and end dates when the component is mounted
    this.setStartEndForMonth();
    },

    methods:{
      getHublist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
            result.body.returnvalue.forEach(item=>{
              let tempObj = {id: item.pickuplocationmasterid, name: item.pickuplocationname}
              this.destinationOptions.push(tempObj)
            })

          }
        })
        .catch(ex => {
          console.log('error', ex)
        });
      },

      handleReportChange:function(){
        console.log('this.reportType------>',this.reportType)
        if(this.isSuperAdmin == 1){
          this.destinationhubid=null;
          this.destinationhubidMultiple = []
        }
        this.fromDate = new Date();
        this.toDate = new Date();
        this.selectedMonth = new Date();
        this.items = [];
        this.totalRows = 0;
        this.from_month_date = null;
        this.to_month_date = null;
        // this.getHubOFDListing(1);
      },

      getHubOFDListing: function(pageNo){
        if(this.reportType!=null){
          if(this.reportType=='daywise')
            this.getHubDaywiseOFDListing(pageNo)
          else
            this.getHubMonthwiseOFDListing(pageNo)
        }
        else{
          this.$fire({
            text: "Please Select Report Type",
            type: "warning",
            timer: 30000
          }); 
        }
      },

      getHubDaywiseOFDListing: function(pageNo){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        //var hubId = userInfo.pickuplocationmasterid;
        this.isBusy = true;

        if(pageNo==1){
          this.items = [];
          this.totalRows = 0;
          this.noofpages = 0;
        }

        if(!this.destinationhubid){
          this.$fire({
            text: "Please Select Hub!!!",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }

        if(this.fromDate > this.toDate){
          this.$fire({
            text: "From date must be smaller than To date",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
        }
        else{
          const Obj = {
            list_type: this.reportType,
            from_date: this.formatDate(this.fromDate),
            to_date: this.formatDate(this.toDate),
            hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
            limit: this.perPage,
            page_no: pageNo ? pageNo : 1     
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFDReportListing`,Obj)
          .then(result=>{
            if(result.status==200){
              if(result.body && result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.totalCount;
                this.noofpages=parseInt(this.totalRows)/this.perPage;
                this.noofpages=Math.ceil( this.noofpages);
                console.log("noofpages-->",this.noofpages)
              }
              else{
                this.items = [];
                this.totalRows = 0;
                this.noofpages = 0;
                this.$fire({
                  text: result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                });
              }
            }else{
              this.items = [];
              this.totalRows = 0;
              this.noofpages = 0;
              this.$fire({
                text: "Error while fetching Data!!!",
                type: "warning",
                timer: 30000
              }); 
            }                   
            this.isBusy = false;
          })
          .catch(ex =>{
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            }); 
            this.isBusy = false;
            console.log('error',ex)
          })
        }
      },

      getHubMonthwiseOFDListing: function(pageNo){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        this.isBusy = true;

        if((this.isSuperAdmin==1 && !this.destinationhubidMultiple.length>0) || (this.isSuperAdmin!=1 && !this.destinationhubid)){
          this.$fire({
            text: "Please Select Hub!!!",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }

        if(this.selectedMonth == null || this.selectedMonth == undefined){
          this.$fire({
            text: "Please Select Month",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
        }
        else{
          let selectedHubId = null
          if(this.isSuperAdmin==1){
            selectedHubId = this.destinationhubidMultiple.toString();
          }else{
            selectedHubId = this.destinationhubid ? this.destinationhubid.toString() : "";
          }

          const Obj = {
            list_type: this.reportType,
            // hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
            hub_id: selectedHubId,
            month:this.formatMonth(this.selectedMonth),
            from_month_date: this.from_month_date ? this.formatDate(this.from_month_date) : null,
            to_month_date: this.to_month_date ? this.formatDate(this.to_month_date) : null,
            limit: this.perPage,
            page_no: pageNo ? pageNo : 1     
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFDReportListing`,Obj)
          .then(result=>{
            console.log("status code-->",result.status)
            if(result.status==200){
              if(result.body && result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.totalCount;
                this.noofpages=parseInt(this.totalRows)/this.perPage;
                this.noofpages=Math.ceil( this.noofpages);
                console.log("noofpages-->",this.noofpages)
              }
              else{
                this.items = [];
                this.totalRows = 0;
                this.noofpages = 0;
                this.$fire({
                  text: result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                });
              }
            }else{
              this.items = [];
              this.totalRows = 0;
              this.noofpages = 0;
              this.$fire({
                text: "Error while fetching Data!!!",
                type: "warning",
                timer: 30000
              }); 
            }           
             this.isBusy = false;
            })
          .catch(ex =>{
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            }); 
            this.isBusy = false;
            console.log('error',ex)
          })
        }
      },

      getReport(){
        if(this.reportType=='daywise')
          this.downloadHubDayWiseOFDReport()
        else
          this.downloadHubMonthWiseOFDReport()
      },

      downloadHubDayWiseOFDReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;

        const Obj={
          list_type: this.reportType,
          from_date: this.formatDate(this.fromDate),
          to_date: this.formatDate(this.toDate),
          hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFDReportCsv`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadReport(result.body,'hubDayWiseOFDReport.csv')
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadHubMonthWiseOFDReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;

        let selectedHubId = null
        if(this.isSuperAdmin==1){
          selectedHubId = this.destinationhubidMultiple.toString();
        }else{
          selectedHubId = this.destinationhubid ? this.destinationhubid.toString() : "";
        }

        const Obj={
          list_type: this.reportType,
          month: this.formatMonth(this.selectedMonth),
          // hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
          hub_id: selectedHubId,
          from_month_date: this.from_month_date ? this.formatDate(this.from_month_date) : null,
          to_month_date: this.to_month_date ? this.formatDate(this.to_month_date) : null,
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseOFDReportCsv`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadReport(result.body,'hubMonthWiseOFDReport.csv')
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadReport(data,fileName){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      viewDetails(data,name){
        this.countDetails = data,
        this.countName = name,
        this.perPage1 = this.reportType=='daywise' ? 50 : 500,
        this.items1=[];
        this.totalRowsCount=0;
        this.noofpages1=0;
        this.currentPage1=1;
        this.detailsModal=true;
        this.displayHubOFDCountDetails(1);
        // this.totalRowsCount=data;
      },

      displayHubOFDCountDetails:function(pageNo){
        console.log("details api called")
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.isBusy1 =true;

        let Obj={}
        if(this.reportType=='daywise'){
          Obj = {
            list_type: this.reportType,
            date : this.countDetails.inscan_date,
            hub_id : this.countDetails.hub_id.toString(),
            count_name:this.countName,
            limit:this.perPage1,
            page_no: pageNo ? pageNo : 1,
            // downloadAsCSV: 'false' 
          }
        }
        else{
          Obj = {
            list_type: this.reportType,
            month: this.countDetails.inscan_month,
            hub_id: this.countDetails.hub_id.toString(),
            count_name:this.countName,
            limit:this.perPage1,
            page_no: pageNo ? pageNo : 1,
            // downloadAsCSV: 'false'
            from_month_date: this.from_month_date ? this.formatDate(this.from_month_date) : null,
            to_month_date: this.to_month_date ? this.formatDate(this.to_month_date) : null
          }
        }

        console.log("count details obj--> ",Obj)
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForHubwiseOFDListingCount`,Obj)
        .then(result=>{
          if(result.status==200){
            if(result.body && result.body.returnmsg === 'Successful'){
              this.items1=result.body.returnvalue;
              this.totalRowsCount=result.body.totalCount;
              this.noofpages1=parseInt(this.totalRowsCount)/this.perPage1;
              this.noofpages1=Math.ceil( this.noofpages1);
              //this.detailsModal=true;
              console.log("noofpages1-->",this.noofpages1)
            }
            else{
              //this.detailsModal=false;
              this.items1=[];
              this.totalRowsCount=0;
              this.noofpages1=0,
              this.$fire({
                text:result.body.returnvalue,
                type: "warning",
                timer: 30000
              }); 
            }
          }else{
            this.items1=[];
            this.totalRowsCount=0;
            this.noofpages1=0
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            }); 
          }    
          this.isBusy1 = false;
        })
        .catch(ex=>{
          this.items1=[];
          this.totalRowsCount=0;
          this.noofpages1=0
          this.$fire({
            text: "Error while fetching Data!!!",
            type: "warning",
            timer: 30000
          });
          this.isBusy1 = false;
          console.log('error',ex)
        })

      },

      clickCallback(pageNo){
        this.currentPage1=pageNo;
        this.displayHubOFDCountDetails(pageNo);
      },

      disabledDate(date) {
        let today = new Date();
        let startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        let endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        return date > endOfMonth;
    },

      refresh(){
        if(this.isSuperAdmin == 1){
          this.destinationhubid=null;
          this.destinationhubidMultiple = []
        }
        this.fromDate = new Date();
        this.toDate = new Date();
        this.selectedMonth = new Date();
        this.items = [];
        this.totalRows = 0;
        this.noofpages = 0;
        this.from_month_date = null;
        this.to_month_date = null;
        //this.getHubOFDListing(1);
      },

      countDetailsReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        let Obj={}
        if(this.reportType=='daywise'){
          Obj = {
            list_type: this.reportType,
            date : this.countDetails.inscan_date,
            hub_id : this.countDetails.hub_id.toString(),
            count_name:this.countName,
            limit:this.perPage1,
            page_no: 1,
            downloadAsCSV: 'true'
          }
        }
        else{
          Obj = {
            list_type: this.reportType,
            month: this.countDetails.inscan_month,
            hub_id: this.countDetails.hub_id.toString(),
            count_name:this.countName,
            limit:this.perPage1,
            page_no: 1,
            downloadAsCSV: 'true',
            from_month_date: this.from_month_date ? this.formatDate(this.from_month_date) : null,
            to_month_date: this.to_month_date ? this.formatDate(this.to_month_date) : null,
          }
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForHubwiseOFDListingCount`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadCountReport(result.body)
          }
          else{
            this.downloadcountdetailsreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadCountReport(data) {
        const csvData = data;
        console.log("Data for download---> ", csvData);

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const anchor = document.createElement('a');
        const url = URL.createObjectURL(blob);

        anchor.href = url;
        anchor.download = 'hubWiseOFDReportCountDetails.csv';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
      },


      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },

      formatMonth: function(date){
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        return [month, year].join("-");
      },

      setStartEndForMonth: function(){
        console.log(this.selectedMonth, 'selectedMonth')
        if (this.selectedMonth) {
          const year = this.selectedMonth.getFullYear();
          const month = this.selectedMonth.getMonth(); // Month is zero-based in JS Date

          // Calculate the first and last days of the month
          this.firstDayOfSelectedMonth = new Date(year, month, 1);
          this.lastDayOfSelectedMonth = new Date(year, month + 1, 0);

          // Automatically set the `from_month_date` to the first day of the month
          this.from_month_date = this.firstDayOfSelectedMonth;
          this.to_month_date = this.lastDayOfSelectedMonth;
        }
        // console.log('this.selectedMonth------>',this.selectedMonth)
        // this.firstDayOfSelectedMonth = this.formatDate(new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth(), 1));
        // this.lastDayOfSelectedMonth = this.formatDate(new Date(this.selectedMonth.getFullYear(), this.selectedMonth.getMonth() + 1, 0));
        // console.log('this.firstDayOfSelectedMonth 2',this.firstDayOfSelectedMonth)
        // console.log('this.lastDayOfSelectedMonth 2',this.lastDayOfSelectedMonth)
        // this.from_month_date = null;
        // this.to_month_date = null;
      },

      resetToMonthDate: function(){
        this.to_month_date = null;
      },

      checkIfGreaterThanFromMonthDate: function(){
        console.log('checkIfGreaterThanFromMonthDate')
        let fromDate = new Date(this.from_month_date)
        let toDate = new Date(this.to_month_date)
        console.log('fromDate---->',fromDate)
        console.log('toDate------>',toDate)
        if(toDate < fromDate){
          this.$fire({
            text: "To Date Should be grater than from date!",
            type: "warning",
            timer: 3000
          });
          this.to_month_date = null;
        }
      },
    }
  }
</script>

<style>

</style>